import React from 'react';

function TroncSkeleton() {
    // Create 4 columns with 5 boxes each to simulate a typical tronc
    const columns = 4;
    const boxesPerColumn = 5;

    return (
        <div className="tronc-skeleton">
            <div className="tronc-skeleton-content">
                <div className="skeleton-position-labels">
                    {Array.from({ length: boxesPerColumn + 2 }).map((_, i) => (
                        <div key={i} className="skeleton-label shimmer" />
                    ))}
                </div>
                <div className="skeleton-rengles">
                    {Array.from({ length: columns }).map((_, colIdx) => (
                        <div key={colIdx} className="skeleton-rengla">
                            {Array.from({ length: boxesPerColumn }).map((_, boxIdx) => (
                                <div key={boxIdx} className="skeleton-box shimmer" />
                            ))}
                            <div className="skeleton-fusta shimmer" />
                            <div className="skeleton-nom shimmer" />
                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
                .tronc-skeleton {
                    background: #f5f5f5;
                    border-radius: 8px;
                    padding: 1rem;
                    margin-bottom: 1rem;
                    min-height: 280px;
                }

                .tronc-skeleton-content {
                    display: flex;
                    margin-top: 1rem;
                    min-height: 200px;
                }

                .skeleton-position-labels {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    gap: 8px;
                    padding: 0.25rem;
                    min-width: 70px;
                    margin-bottom: 10px;
                }

                .skeleton-label {
                    height: 35px;
                    width: 50px;
                    border-radius: 4px;
                    margin: 3px 0;
                }

                .skeleton-rengles {
                    display: flex;
                    gap: 1rem;
                    padding-bottom: 1rem;
                    align-items: flex-end;
                    flex: 1;
                }

                .skeleton-rengla {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 6px;
                    padding: 0.5rem;
                    min-width: 70px;
                }

                .skeleton-box {
                    width: 65px;
                    height: 25px;
                    border-radius: 4px;
                    margin: 3px;
                }

                .skeleton-fusta {
                    width: 65px;
                    height: 25px;
                    border-radius: 4px;
                    margin: 3px;
                    margin-top: 8px;
                }

                .skeleton-nom {
                    width: 50px;
                    height: 20px;
                    border-radius: 4px;
                    margin-top: 6px;
                }

                .shimmer {
                    background: linear-gradient(
                        90deg,
                        #e0e0e0 25%,
                        #f0f0f0 50%,
                        #e0e0e0 75%
                    );
                    background-size: 200% 100%;
                    animation: shimmer 1.5s infinite;
                }

                @keyframes shimmer {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }
            `}</style>
        </div>
    );
}

export default TroncSkeleton;
